import { render, staticRenderFns } from "./mensalidadespagas.vue?vue&type=template&id=4420a217&"
import script from "./mensalidadespagas.vue?vue&type=script&lang=js&"
export * from "./mensalidadespagas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports